export default __webpack_public_path__ + "6fb7802.png";